import { SharedModule } from "../../../shared/shared.module";
import { AssociationsDetailsComponent } from "./associations-details.component";
import { AssociationsDetailsResolver } from "./associations-details.resolver";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalModule, BsDatepickerModule } from "ngx-bootstrap";
import { ImageCropperModule } from "ngx-image-cropper";
import { ImageCropperComponent } from "./image-cropper/image-cropper.component";
import { AssociationTypesResolver } from "./association-type.resolver";
import { NgSelectModule } from "@ng-select/ng-select";
import { OddsResolver } from "./odds.resolver";
import { RegionsResolver } from "./regions.resolver";

@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    ImageCropperModule,
    ModalModule,
    BsDatepickerModule,
    NgSelectModule,
  ],
  declarations: [AssociationsDetailsComponent, ImageCropperComponent],
  exports: [AssociationsDetailsComponent],
  providers: [
    AssociationsDetailsResolver,
    AssociationTypesResolver,
    OddsResolver,
    RegionsResolver,
  ],
  entryComponents: [ImageCropperComponent],
})
export class AssociationsDetailsModule {}
